import React, { useState, useEffect, useContext } from "react";
import { Form, Input, Select, Radio } from "antd";
import { CallActionBtn } from "../../pages/uih/wf_controllers/BtnController/dynamicAction";
import Api from "../../services/ServiceApi";
import { useSelector } from "react-redux";
import {
  defaultFormItemLayout,
  defaultFormButtonLayout,
} from "../utility/form_layout";
import Renderbtn from "../../pages/uih/wf_controllers/BtnController/renderButton";
import { StatusInfo } from "../utility/status_info_modal";
import { authUserContext } from "../../contexts";
const { Option } = Select;

export default function ApproveProcessForm({
  sendData,
  callbackFunction,
  position = "top",
  renderComponents = null,
  defaultApprove,
  disableRadio,
}) {
  const [form] = Form.useForm();
  const [Approvelist, setApprovelist] = useState([]);
  const [disableBtn, setdisableBtn] = useState(false);
  const [LoadingText, setLoadingText] = useState("Loading");
  const [StatusMode, setStatusMode] = useState("success");
  const [Spin, setSpin] = useState(true);
  const { masterLang: language, factUpdate } = useSelector(
    (state) => state.masterLang
  );

  useEffect(() => {
    console.log("sendData", sendData);
    let fecthSuccess = false;
    if (!fecthSuccess) {
      Api.post("Approve/get_approve_status_list", {}).then((res) => {
        const { result, data } = res.data;
        if (result.code === "P") {
          setApprovelist(data.approve_status_list);
        }
      });
      if (defaultApprove !== null) {
        const dataReq = {
          target: {
            value: defaultApprove,
          },
        };
        getReason(dataReq);
      }
    }
    return () => {
      fecthSuccess = true;
    };
  }, []);

  const { approve_id, last_approve_level_seq, job_id, mode, detail } = sendData;
  const { CompanyId, OperatorId, ProjectId, locale } =
    useContext(authUserContext);
  const onSubmit = (values) => {
    setdisableBtn(true);
    setLoadingText("Loading Action");
    const { type, reason, remark } = values;
    CallActionBtn["callApproveProcess"](
      approve_id,
      last_approve_level_seq,
      type,
      reason,
      remark,
      job_id,
      mode ?? "normal",
      detail
    )
      .then((res) => {
        if (res.success) {
          setLoadingText(res.msg);
          setSpin(false);
        } else {
          setLoadingText(`${res.msg}`);
          setSpin(false);
          setStatusMode("error");
        }
      })
      .catch((err) => {
        setLoadingText(`${err.msg}`);
        setSpin(false);
        setStatusMode("error");
      });
  };

  const [listReason, setlistReason] = useState([]);
  const getReason = (e) => {
    const flag =
      Number(e.target.value) === 1 ? `APPROVE_REASON` : `REJECT_REASON`;
    Api.post("get_servicemareason", {
      company_id: CompanyId,
      operator_id: OperatorId,
      project_id: ProjectId,
      ma_reason: flag,
    }).then((res) => {
      const { result, data } = res.data;
      if (result.code === "P") {
        const filterList = data.serult_service_reason?.map((s) => ({
          label: s.service_ma_reason_desc,
          value: s.service_ma_reason_id,
        }));
        setlistReason(filterList);
      }
    });
  };

  return (
    <>
      {disableBtn ? (
        <StatusInfo
          showSpinIcon={Spin}
          statusText={LoadingText}
          mode={StatusMode}
          callbackFunction={callbackFunction}
        ></StatusInfo>
      ) : (
        <>
          {position === "top" ? renderComponents : null}
          <Form
            form={form}
            name="approve_process_form"
            {...defaultFormItemLayout}
            onFinish={onSubmit}
            initialValues={
              defaultApprove !== null ? { type: defaultApprove } : null
            }
          >
            <Form.Item
              name="type"
              label={
                factUpdate ? language[locale]["approve_type"] : `Approve Type`
              }
              rules={[
                { required: true, message: "Please select Approve or Reject." },
              ]}
            >
              <Radio.Group onChange={getReason} disabled={disableRadio}>
                {Approvelist?.map((s, i) => (
                  <Radio
                    key={`approve_radio_list_index_${i}`}
                    value={s.approve_status_id}
                  >
                    <span className="default-thai-font">
                      {s.approve_status_name}
                    </span>
                  </Radio>
                ))}
              </Radio.Group>
            </Form.Item>
            <Form.Item
              name="reason"
              label={factUpdate ? language[locale]["reason"] : `Reason`}
            >
              <Select placeholder="Please Select">
                {listReason?.map((s, i) => (
                  <Option
                    value={s.value}
                    key={`reason_approve_option_index_${i}`}
                  >
                    <span className="default-thai-font">{s.label}</span>
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="remark"
              label={factUpdate ? language[locale]["remark"] : `Remark`}
            >
              <Input.TextArea rows="3"></Input.TextArea>
            </Form.Item>
            {position === "buttom" ? renderComponents : null}
            <Form.Item {...defaultFormButtonLayout}>
              <div className="d-flex justify-content-end flex-wrap pt-2">
                <Renderbtn
                  renderBtn={{
                    visible: true,
                    html_tag: "button",
                    type: "Text",
                    text: factUpdate
                      ? language[locale]["btn_cancel"]
                      : `Cancel`,
                    css: "btn btn-xs btn-light",
                  }}
                  btnMiddleware={() => callbackFunction()}
                  index="view_btn_closemodal"
                  item={null}
                  disable={false}
                ></Renderbtn>
                <Renderbtn
                  renderBtn={{
                    visible: true,
                    html_tag: "button",
                    type: "Text",
                    text: factUpdate
                      ? language[locale]["btn_confirm"]
                      : `Confirm`,
                    css: "btn btn-xs btn-submit",
                  }}
                  btnMiddleware={() => form.submit()}
                  index="view_submit_form"
                  item={null}
                  disable={false}
                ></Renderbtn>
              </div>
            </Form.Item>
          </Form>
        </>
      )}
    </>
  );
}
